import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomerRoutingModule } from './customer-routing.module';
import { AdvancedCalculatorComponent } from './advanced-calculator/advanced-calculator.component';
import { SharedModule } from '../../common/shared.module';
import {
  SolarCalculatorResultModule,
} from '../../common/components/solar-calculation-result/solar-calculator-result.module';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { SavedPowerPlantsComponent } from './saved-power-plants/saved-power-plants.component';
import { PowerPlantCardComponent } from './saved-power-plants/power-plant-card/power-plant-card.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PowerPlantDetailsComponent } from './power-plant-details/power-plant-details.component';
import {
  BasicPowerPlantInfoComponent,
} from '../../common/components/basic-power-plant-info/basic-power-plant-info.component';
import { ImplementationPlanComponent } from './implementation-plan/implementation-plan.component';
import { CompanyTableComponent } from './implementation-plan/company-table/company-table.component';
import { CompanyCardComponent } from '../../common/components/company-card/company-card.component';
import { OfferRequestsComponent } from './offer-requests/offer-requests.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { EditOfferRequestComponent } from './offer-requests/edit-offer-request/edit-offer-request.component';
import { PricesComponent } from '../../common/components/prices/prices.component';
import {
  ResultTitleComponent,
} from '../../common/components/solar-calculation-result/result-title/result-title.component';
import { UserHasRolePipe } from '../../common/pipes/user-has-role.pipe';
import { CalculatorModule } from '../../common/components/calculator/calculator.module';
import {
  PayForFullComponent,
} from '../../common/components/solar-calculation-result/pay-for-full/pay-for-full.component';
import { SimpleImplementationPlanComponent } from './simple-implementation-plan/simple-implementation-plan.component';
import { BusinessDashboardComponent } from './business-dashboard/business-dashboard.component';
import { StatDataMapComponent } from '../../common/components/stats-components/stat-data-map/stat-data-map.component';
import { StatsTableComponent } from '../../common/components/stats-components/stats-table/stats-table.component';


@NgModule({
  declarations: [
    AdvancedCalculatorComponent,
    SavedPowerPlantsComponent,
    PowerPlantDetailsComponent,
    ImplementationPlanComponent,
    OfferRequestsComponent,
    EditOfferRequestComponent,
    SimpleImplementationPlanComponent,
    BusinessDashboardComponent,
  ],
  imports: [
    CommonModule,
    CustomerRoutingModule,
    SharedModule,
    TranslocoModule,
    SolarCalculatorResultModule,
    PowerPlantCardComponent,
    ReactiveFormsModule,
    BasicPowerPlantInfoComponent,
    CompanyTableComponent,
    CompanyCardComponent,
    NgxDatatableModule,
    PricesComponent,
    ResultTitleComponent,
    UserHasRolePipe,
    CalculatorModule,
    PayForFullComponent,
    StatDataMapComponent,
    StatsTableComponent,
  ],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'customer', alias: 'customer' } }],
  exports: [
    AdvancedCalculatorComponent,
  ],
})
export class CustomerModule { }
